// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3IscY","alert":"SettungsInbox_alert__2bEVO"};